export default __webpack_public_path__ + "static/media/close.ab29894f.svg";